module.exports = __webpack_public_path__ + "static/img/logo-dark.55e3433.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-dark.jpeg
// module id = hNNv
// module chunks = 1